import ShowItemContent from "./ShowItemContent"

const Heading = ({ item, isGroupNote }) => {
  return (
    <>
      {item.content?.trim() ?
        <div className='d-flex flex-column gap-1'>
          <p className='heading fs-18 lh-1'>{ShowItemContent(item, isGroupNote)}</p>
          <p className='text fs-13 lh-1'>{item?.answer}</p>
        </div> : <></>}
    </>
  )
}

export default Heading